import { Component, ElementRef, EventEmitter, HostListener, Input, Output, ViewChild } from '@angular/core';
import { NgClass } from '@angular/common';

import { IconComponent } from '@atoms/icon/icon.component';

@Component({
  selector: 'app-dropdown-button',
  imports: [NgClass, IconComponent],
  templateUrl: './dropdown-button.component.html',
  styleUrls: ['./dropdown-button.component.scss'],
})
export class DropdownButtonComponent {
  @Input() color: 'default' | 'light' = 'default';
  @Input() label: string = '';
  @Input() value?: string;
  @Input() active: boolean = false;
  @Input() disabled: boolean = false;
  @Input() small: boolean = false;
  @Input('mobile-small') mobileSmall: boolean = false;
  @Output() activeChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() clicked: EventEmitter<void> = new EventEmitter<void>();
  @ViewChild('dropdownButton') dropdownButton?: ElementRef;

  @HostListener('document:click', ['$event.target']) clickout(event: HTMLElement): void {
    if (this.disabled) return;
    if (this.active && !event.closest('.dropdown__main')) {
      this.active = false;
      this.activeChange.emit(this.active);
    } else if (event.closest('.dropdown__button') === this.dropdownButton?.nativeElement) {
      this.active = true;
      this.activeChange.emit(this.active);
    }
  }

  click(): void {
    this.clicked.emit();
  }
}
